import React from 'react';
import { Link } from 'react-router-dom'
import { AccessAlarm, EmojiPeople, SupervisedUserCircle,Face } from '@material-ui/icons';

import 'style/BottomNavigation.css'


class BottomNavigation extends React.Component {
  render() {
    return (
      <div class="bottom-navigation" >
        <Link class={`tab-chats ${this.props.selected === '3' ? 'selected' : ''}`} to="/profile">
          <Face className="tabIcon" />
          <span> پروفایل</span>
        </Link>
        <Link class={`tab-chats ${this.props.selected === '2' ? 'selected' : ''}`} to="/chats">
          <SupervisedUserCircle className="tabIcon" />
          <span>مشاوره ها</span>
        </Link>
        {/* <Link class={`tab-requests ${this.props.selected === '1' ? 'selected' : ''}`} to="/consults">
          <EmojiPeople className="tabIcon"/>
          <span> درخواست ها</span>
        </Link> */}

      </div>
    );
  }
}
export default BottomNavigation;